import React from "react";

import { Alert } from "react-bootstrap";
import { CheckoutInfoWarning } from "@src/CommonTypes";

export const CheckoutAlert: React.FC<{
  errorMessages: CheckoutInfoWarning[];
}> = ({ errorMessages }) => {
  const [showAlert, setShowAlert] = React.useState(true);
  return (
    <>
      {showAlert &&
      errorMessages?.map((msg, i) => {
        return (
          <Alert
            variant={msg.level}
            dismissible
            onClose={() => setShowAlert(false)}
            key={i}
          >
            {msg.message}
          </Alert>
        );
      })}
    </>
  );
};
